import React from 'react'

import { useDrop } from 'react-dnd'

function DroppableArea({ children, accept, onMove, className }) {
  const [, drop] = useDrop({
    accept,
    drop(item, monitor) {
      const delta = monitor.getDifferenceFromInitialOffset()
      const left = Math.round(item.left + delta.x)
      const top = Math.round(item.top + delta.y)
      onMove(item.id, left, top)
      return undefined
    },
  })

  return (
    <div ref={drop} className={className}>
      {children}
    </div>
  )
}

DroppableArea.defaultProps = {
  className: 'DroppableArea',
}

export { DroppableArea }
